import { React, useState, useEffect } from 'react'
import Box from '@mui/system/Box'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'

export const setMaxInSingleLine = (containerWidth, avatarVariant, arrLength) => {
  // this function is taking the width of the container, and return the max amount of AdxEmployeeAvatar could have in a single line based on the width of the container
  // containerWidth in px only
  let max

  if (avatarVariant) {
    // 36 is the width set for the avatar (40 or 52 ) minus border on each side
    max = Math.floor(containerWidth / 36)
  } else {
    // 48 is the width set for the avatar (40 or 52 ) minus border on each side
    max = Math.floor(containerWidth / 48)
  }

  if (max >= arrLength) {
    return arrLength
  } else {
    return max
  }
}

const SingleAvatar = ({ name, imgUrl, active, variant, sxContainer }) => {
  const nameInitials = (name) => {
    const namesArray = name?.trim()?.split(' ')
    if (namesArray?.length === 1) return `${namesArray[0]?.charAt(0)}`
    else return `${namesArray[0]?.charAt(0)}${namesArray[namesArray?.length - 1].charAt(0)}`
  }
  return (
    <Box sx={{ ...sxContainer }}>
      {imgUrl ? (
        <CardMedia
          component="img"
          sx={{
            height: variant ? 40 : 52,
            width: variant ? 40 : 52,
            objectFit: 'cover',
            borderRadius: '50%',
            border: '3px solid',
            borderColor: active ? 'alternate.main' : 'gray-line.main',
          }}
          alt={`picture of ${name}`}
          src={imgUrl}
          loading="lazy"
        />
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            height: variant ? 40 : 52,
            width: variant ? 40 : 52,
            objectFit: 'cover',
            borderRadius: '50%',
            border: '3px solid',
            bgcolor: active ? 'alternate.main' : 'gray-line.main',
            borderColor: active ? 'alternate.main' : 'gray-line.main',
          }}
        >
          <Typography variant={variant ? 'body1' : 'h4'} color="white.main">
            {name ? nameInitials(name) : null}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

const AdxEmployeeAvatar = ({
  tooltip,
  tooltipMax,
  noRemainingTooltip,
  data,
  variant,
  max,
  active,
}) => {
  const [dataList, setDataList] = useState(data)
  const arrayLength = dataList?.length
  const slicedData = dataList?.slice(0, max)
  const slicedDataLength = slicedData?.length
  const remainderData = dataList?.slice(max, arrayLength)

  useEffect(() => {
    setDataList(data)
  }, [data])

  if (tooltip) {
    return (
      <Box display={'flex'} width={`calc(100% / ${variant ? '40px' : '52px'})`} flexWrap="wrap">
        {slicedData?.map((item, index) => {
          return (
            <Tooltip title={item?.name}>
              <Box key={index} sx={{ marginRight: '-10px' }}>
                <SingleAvatar
                  name={item?.name}
                  imgUrl={item?.imgUrl}
                  active={active}
                  variant={variant}
                />
              </Box>
            </Tooltip>
          )
        })}
        {slicedDataLength === arrayLength ? null : noRemainingTooltip ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{
              objectFit: 'cover',
              borderRadius: '50%',
              backgroundColor: 'alternate.main',
              width: variant ? 40 : 52,
              height: variant ? 40 : 52,
              marginRight: '-10px',
              border: 'alternate.main',
            }}
          >
            <Typography variant={variant ? 'body1' : 'h4'} color="white.main">
              {arrayLength - slicedDataLength}
            </Typography>
          </Box>
        ) : (
          <Tooltip
            placement="bottom"
            title={
              <Box>
                {remainderData
                  .filter((filterItem, index) => index < tooltipMax)
                  .map((item, i) => {
                    return <Typography>{item?.name}</Typography>
                  })}
                {remainderData.length > tooltipMax ? (
                  <Typography>
                    and {remainderData.length - tooltipMax}{' '}
                    {remainderData.length - tooltipMax > 1 ? 'others' : 'other'}
                  </Typography>
                ) : null}
              </Box>
            }
          >
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{
                objectFit: 'cover',
                borderRadius: '50%',
                backgroundColor: 'alternate.main',
                width: variant ? 40 : 52,
                height: variant ? 40 : 52,
                marginRight: '-10px',
                border: 'alternate.main',
              }}
            >
              <Typography variant={variant ? 'body1' : 'h4'} color="white.main">
                {arrayLength - slicedDataLength}
              </Typography>
            </Box>
          </Tooltip>
        )}
      </Box>
    )
  }

  return (
    <Box display={'flex'} width={`calc(100% / ${variant ? '40px' : '52px'})`} flexWrap="wrap">
      {slicedData?.map((item, index) => {
        return (
          <Box key={index} sx={{ marginRight: '-10px' }}>
            <SingleAvatar
              name={item?.name}
              imgUrl={item?.imgUrl}
              active={active}
              variant={variant}
            />
          </Box>
        )
      })}
      {slicedDataLength === arrayLength ? null : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            objectFit: 'cover',
            borderRadius: '50%',
            backgroundColor: 'alternate.main',
            width: variant ? 40 : 52,
            height: variant ? 40 : 52,
            marginRight: '-10px',
            border: 'alternate.main',
          }}
        >
          <Typography variant={variant ? 'body1' : 'h4'} color="white.main">
            {arrayLength - slicedDataLength}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default AdxEmployeeAvatar
